document.addEventListener("DOMContentLoaded", () => {
  const hubWrapper = document.querySelector('.learning-hub-wrapper');
  if (!hubWrapper) return;
  const customerId = hubWrapper.dataset.customerId;
  const commentsKey = `page_comments_${customerId}`;

  const LH_CFG = window.EWHQ_LEARNING_HUB_CONFIG || {};
  const CUSTOMER_NAME = LH_CFG.customerName;
  const CUSTOMER_INITIAL = LH_CFG.customerInitial;
  const CREDIT_SYMBOL = LH_CFG.creditSymbol;
  const QA_SYNC_URL = LH_CFG.qaSyncUrl || "";

  let commentsStore = {};
  try {
    const rawComments = localStorage.getItem(commentsKey);
    if (rawComments) commentsStore = JSON.parse(rawComments);
  } catch (e) {}

  // DOM Declarations
  const lessons = Array.from(document.querySelectorAll('.lesson-item'));
  const stagePlayer = document.getElementById('stage-player');
  const videoWrapper = document.getElementById('video-wrapper');
  const nativeVideoWrapper = document.getElementById('native-video-wrapper');
  const articleStage = document.getElementById('article-stage');
  const stageEl = document.getElementById('lh-stage');
  const readingFill = document.getElementById('reading-progress-fill');
  const stageTitle = document.getElementById('stage-title');
  const stageDesc = document.getElementById('stage-desc');
  const completeBtn = document.getElementById('complete-btn');
  const navBalance = document.getElementById('nav-credit-balance');
  const navProgressFill = document.getElementById('nav-progress-fill');
  const navPct = document.getElementById('nav-pct');
  const prevBtn = document.getElementById('lesson-prev-btn');
  const nextBtn = document.getElementById('lesson-next-btn');
  const totalLessons = lessons.length || 1;

  let currentLessonId = null;
  let currentLessonCredits = 0;

  function isComplete(id) { return !!(window.EWHQ && window.EWHQ.isLessonComplete(id)); }

  /* ============================================================
     VIDEO URL NORMALIZATION
     Accepts watch links, share links, shorts, or embed URLs and
     always produces a working embed URL.
  ============================================================ */
  function normalizeVideoUrl(url) {
    if (!url) return '';
    url = url.trim();
    let m;
    // youtu.be/ID
    m = url.match(/youtu\.be\/([A-Za-z0-9_-]{6,})/);
    if (m) return 'https://www.youtube.com/embed/' + m[1];
    // youtube.com/watch?v=ID
    m = url.match(/[?&]v=([A-Za-z0-9_-]{6,})/);
    if (m && /youtube\.com/.test(url)) return 'https://www.youtube.com/embed/' + m[1];
    // youtube.com/shorts/ID or /live/ID
    m = url.match(/youtube\.com\/(?:shorts|live)\/([A-Za-z0-9_-]{6,})/);
    if (m) return 'https://www.youtube.com/embed/' + m[1];
    // already an embed URL (youtube or vimeo player)
    if (/youtube\.com\/embed\//.test(url) || /player\.vimeo\.com\/video\//.test(url)) return url;
    // vimeo.com/ID
    m = url.match(/vimeo\.com\/(\d+)/);
    if (m) return 'https://player.vimeo.com/video/' + m[1];
    return url; // anything else: trust as-is
  }

  /* ============================================================
     MODULE COLLAPSE + PER-MODULE PROGRESS (Khan-style units)
  ============================================================ */
  const moduleHeaders = Array.from(document.querySelectorAll('.module-header[data-module-id]'));

  moduleHeaders.forEach(header => {
    header.addEventListener('click', () => {
      header.classList.toggle('collapsed');
      const id = header.dataset.moduleId;
      lessons.forEach(l => {
        if (l.dataset.module === id) l.classList.toggle('module-collapsed', header.classList.contains('collapsed'));
      });
    });
  });

  function updateModuleBadges() {
    moduleHeaders.forEach(header => {
      const id = header.dataset.moduleId;
      const badge = header.querySelector('.module-progress-badge');
      if (!badge) return;
      const inModule = lessons.filter(l => l.dataset.module === id);
      const done = inModule.filter(l => isComplete(l.dataset.id)).length;
      badge.textContent = done + ' / ' + inModule.length;
      badge.classList.toggle('done', inModule.length > 0 && done === inModule.length);
    });
  }

  /* ============================================================
     GLOBAL PROGRESS + SIDEBAR STATE
  ============================================================ */
  function syncUI() {
    navBalance.innerText = window.EWHQ ? window.EWHQ.getCredits() : 0;

    let completedCount = 0;
    lessons.forEach(lesson => {
      if (isComplete(lesson.dataset.id)) { lesson.classList.add('completed'); completedCount++; }
      else { lesson.classList.remove('completed'); }
    });

    const pct = Math.round((completedCount / totalLessons) * 100) || 0;
    navProgressFill.style.width = pct + '%';
    navPct.innerText = pct + '%';

    updateModuleBadges();
    if (typeof updateCertificate === 'function') updateCertificate();
    if (currentLessonId) updateButtonState(isComplete(currentLessonId));
  }

  function updateButtonState(isCompleted) {
    if (isCompleted) {
      completeBtn.classList.add('completed');
      completeBtn.innerHTML = `Protocol Complete <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="20 6 9 17 4 12"></polyline></svg>`;
      completeBtn.disabled = true;
    } else {
      completeBtn.classList.remove('completed');
      const verb = getCurrentKind() === 'article' ? 'Mark as Read & Earn' : 'Complete & Earn';
      completeBtn.innerHTML = `${verb} ${currentLessonCredits} ${escapeHTML(CREDIT_SYMBOL)}`;
      completeBtn.disabled = false;
    }
  }

  function getCurrentKind() {
    const el = lessons.find(l => l.dataset.id === currentLessonId);
    return el ? (el.dataset.kind || 'video') : 'video';
  }

  /* ============================================================
     STAGE RENDERING (video embed / uploaded video / article)
  ============================================================ */
  function showStageMode(mode) {
    videoWrapper.classList.toggle('hidden', mode !== 'video');
    nativeVideoWrapper.classList.toggle('hidden', mode !== 'upload');
    articleStage.classList.toggle('visible', mode === 'article');
    if (mode !== 'video' && stagePlayer.src) stagePlayer.src = '';
    if (mode !== 'upload') nativeVideoWrapper.innerHTML = '';
    if (readingFill) readingFill.style.width = '0%';
  }

  function loadLesson(lessonEl, opts) {
    opts = opts || {};
    lessons.forEach(l => l.classList.remove('active'));
    lessonEl.classList.add('active');
    lessonEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

    currentLessonId = lessonEl.dataset.id;
    currentLessonCredits = parseInt(lessonEl.dataset.credits, 10) || 0;
    const kind = lessonEl.dataset.kind || 'video';

    stageTitle.innerText = lessonEl.dataset.title;
    stageDesc.innerText = lessonEl.dataset.desc;

    const tpl = document.querySelector(`template[data-lesson-content="${currentLessonId}"]`);

    if (kind === 'article' && tpl) {
      showStageMode('article');
      articleStage.innerHTML = '';
      articleStage.appendChild(tpl.content.cloneNode(true));
    } else if (kind === 'upload' && tpl) {
      showStageMode('upload');
      nativeVideoWrapper.appendChild(tpl.content.cloneNode(true));
    } else {
      const embedUrl = normalizeVideoUrl(lessonEl.dataset.url);
      if (embedUrl) {
        showStageMode('video');
        if (stagePlayer.src !== embedUrl) stagePlayer.src = embedUrl;
        if (comingSoonEl) comingSoonEl.classList.add('hidden');
      } else {
        // No video attached yet — show a graceful "coming soon" state instead
        // of a broken/blank embed.
        showStageMode('video');
        if (stagePlayer.src) stagePlayer.src = '';
        showComingSoon();
      }
    }

    if (!opts.skipScroll) stageEl.scrollTo({ top: 0, behavior: 'smooth' });

    // Remember position for "continue where you left off"
    if (window.EWHQ && window.EWHQ.setPref) window.EWHQ.setPref('lh_last_lesson', currentLessonId);

    updateButtonState(isComplete(currentLessonId));
    updateLessonNav();
    renderQuiz(lessonEl);
    parseAndRenderComments();
  }

  /* ============================================================
     "COMING SOON" STATE for lessons without a video yet
  ============================================================ */
  let comingSoonEl = null;
  function showComingSoon() {
    if (!videoWrapper) return;
    if (!comingSoonEl) {
      comingSoonEl = document.createElement('div');
      comingSoonEl.className = 'lh-coming-soon';
      comingSoonEl.style.cssText =
        'position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;' +
        'gap:10px;text-align:center;background:rgba(13,15,18,0.9);color:#fff;padding:2rem;';
      comingSoonEl.innerHTML =
        '<svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" opacity="0.8"><polygon points="5 3 19 12 5 21 5 3"/></svg>' +
        '<strong style="font-size:1.05rem;">Lesson video coming soon</strong>' +
        '<span style="opacity:0.7;font-size:0.9rem;max-width:340px;">This lesson is being produced. You can still read the notes and earn credits below.</span>';
      videoWrapper.style.position = 'relative';
      videoWrapper.appendChild(comingSoonEl);
    }
    comingSoonEl.classList.remove('hidden');
  }

  /* ============================================================
     LESSON QUIZ (bonus credits, awarded once per lesson)
  ============================================================ */
  const quizEl = document.getElementById('lh-quiz');
  const quizQ = document.getElementById('lh-quiz-question');
  const quizOpts = document.getElementById('lh-quiz-options');
  const quizFb = document.getElementById('lh-quiz-feedback');
  const quizCreditsEl = document.getElementById('lh-quiz-credits');

  function quizDoneKey(id) { return 'lh_quiz_' + id; }
  function quizIsDone(id) { return !!(window.EWHQ && window.EWHQ.getPref(quizDoneKey(id))); }

  function renderQuiz(lessonEl) {
    if (!quizEl) return;
    const q = lessonEl.dataset.quizQ;
    if (!q) { quizEl.hidden = true; return; }
    const opts = [lessonEl.dataset.quizO1, lessonEl.dataset.quizO2, lessonEl.dataset.quizO3, lessonEl.dataset.quizO4].filter(Boolean);
    const answer = parseInt(lessonEl.dataset.quizAnswer, 10) || 1;
    const credits = parseInt(lessonEl.dataset.quizCredits, 10) || 0;
    const lid = lessonEl.dataset.id;

    quizEl.hidden = false;
    if (quizCreditsEl) quizCreditsEl.textContent = credits;
    if (quizQ) quizQ.textContent = q;
    if (quizFb) quizFb.textContent = '';
    const alreadyDone = quizIsDone(lid);

    quizOpts.innerHTML = opts.map((o, i) =>
      '<button type="button" class="lh-quiz-opt" data-opt="' + (i + 1) + '"' + (alreadyDone ? ' disabled' : '') + '>' + escapeHTML(o) + '</button>'
    ).join('');

    if (alreadyDone) {
      const correctBtn = quizOpts.querySelector('[data-opt="' + answer + '"]');
      if (correctBtn) correctBtn.classList.add('correct');
      if (quizFb) { quizFb.style.color = 'var(--lh-success)'; quizFb.textContent = '✓ Completed — bonus credits already earned.'; }
      return;
    }

    quizOpts.querySelectorAll('.lh-quiz-opt').forEach(btn => {
      btn.addEventListener('click', () => {
        const chosen = parseInt(btn.dataset.opt, 10);
        quizOpts.querySelectorAll('.lh-quiz-opt').forEach(b => b.disabled = true);
        const correctBtn = quizOpts.querySelector('[data-opt="' + answer + '"]');
        if (chosen === answer) {
          btn.classList.add('correct');
          if (window.EWHQ) {
            window.EWHQ.addCredits(credits);
            window.EWHQ.setPref(quizDoneKey(lid), true);
          }
          if (quizFb) { quizFb.style.color = 'var(--lh-success)'; quizFb.textContent = '✓ Correct! +' + credits + ' ' + CREDIT_SYMBOL + ' added.'; }
          celebrate();
          syncUI();
        } else {
          btn.classList.add('wrong');
          if (correctBtn) correctBtn.classList.add('correct');
          if (quizFb) { quizFb.style.color = '#ff6b6b'; quizFb.textContent = 'Not quite — the highlighted answer is correct. Review the lesson and it still counts toward completion.'; }
          // Allow retry after a beat (no credits on wrong first try).
          setTimeout(() => renderQuiz(lessonEl), 2500);
        }
      });
    });
  }

  lessons.forEach(lesson => lesson.addEventListener('click', () => loadLesson(lesson)));

  /* ============================================================
     PREV / NEXT NAVIGATION
  ============================================================ */
  function updateLessonNav() {
    const idx = lessons.findIndex(l => l.dataset.id === currentLessonId);
    const prev = idx > 0 ? lessons[idx - 1] : null;
    const next = idx >= 0 && idx < lessons.length - 1 ? lessons[idx + 1] : null;
    prevBtn.disabled = !prev;
    nextBtn.disabled = !next;
    document.getElementById('prev-lesson-title').textContent = prev ? prev.dataset.title : '—';
    document.getElementById('next-lesson-title').textContent = next ? next.dataset.title : '—';
  }

  prevBtn.addEventListener('click', () => {
    const idx = lessons.findIndex(l => l.dataset.id === currentLessonId);
    if (idx > 0) loadLesson(lessons[idx - 1]);
  });
  nextBtn.addEventListener('click', () => {
    const idx = lessons.findIndex(l => l.dataset.id === currentLessonId);
    if (idx >= 0 && idx < lessons.length - 1) loadLesson(lessons[idx + 1]);
  });

  /* ============================================================
     READING PROGRESS (articles)
  ============================================================ */
  if (stageEl && readingFill) {
    stageEl.addEventListener('scroll', () => {
      if (!articleStage.classList.contains('visible')) return;
      const scrollable = stageEl.scrollHeight - stageEl.clientHeight;
      readingFill.style.width = (scrollable > 0 ? Math.min(100, (stageEl.scrollTop / scrollable) * 100) : 0) + '%';
    }, { passive: true });
  }

  /* ============================================================
     COMPLETION + CELEBRATION
  ============================================================ */
  function celebrate() {
    const burst = document.createElement('div');
    burst.className = 'celebrate-burst';
    const colors = ['#0071e3', '#f5c453', '#30d158', '#5856d6', '#ff9f0a'];
    for (let i = 0; i < 60; i++) {
      const piece = document.createElement('div');
      piece.className = 'celebrate-piece';
      piece.style.left = Math.random() * 100 + 'vw';
      piece.style.background = colors[i % colors.length];
      piece.style.animationDelay = (Math.random() * 0.4) + 's';
      piece.style.transform = 'rotate(' + Math.random() * 360 + 'deg)';
      burst.appendChild(piece);
    }
    document.body.appendChild(burst);
    setTimeout(() => burst.remove(), 2600);
  }

  completeBtn.addEventListener('click', () => {
    if (!currentLessonId || isComplete(currentLessonId)) return;
    if (window.EWHQ) window.EWHQ.markLessonComplete(currentLessonId, currentLessonCredits);
    celebrate();
    syncUI();
  });

  // Keep UI in sync if credits/lessons change elsewhere (e.g. another tab/section)
  document.addEventListener('ewhq:change', () => { syncUI(); if (typeof applyRecommendations === 'function') applyRecommendations(); });

  /*
   =========================================
   DYNAMIC QA & COMMENTS SYSTEM ENGINE
   =========================================
  */
  let activeTab = 'questions';
  let sortCriteria = 'votes';

  const tabBtns = document.querySelectorAll('.qa-tab-btn');
  const formHeading = document.getElementById('form-heading-text');
  const rawInput = document.getElementById('comment-raw-input');
  const submitBtn = document.getElementById('submit-action-btn');
  const sortSelect = document.getElementById('qa-sort-select');

  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      tabBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      activeTab = btn.dataset.tab;

      if (activeTab === 'questions') {
        formHeading.innerText = 'Submit a Question';
        rawInput.placeholder = 'Ask a question...';
        submitBtn.innerText = 'Post question';
      } else {
        formHeading.innerText = 'Submit a Tip or Thank';
        rawInput.placeholder = 'Write a tip or thank-you note...';
        submitBtn.innerText = 'Post tip / thanks';
      }
      parseAndRenderComments();
    });
  });

  // Sort control
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      sortCriteria = sortSelect.value;
      parseAndRenderComments();
    });
  }

  submitBtn.addEventListener('click', () => {
    const val = rawInput.value.trim();
    if (!val || !currentLessonId) return;

    const key = `${currentLessonId}_${activeTab}`;
    if (!commentsStore[key]) commentsStore[key] = [];

    const entry = {
      id: 'local-' + Date.now(),
      author: CUSTOMER_NAME,
      timestamp: Math.floor(Date.now() / 1000),
      date: new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
      body: val,
      tab: activeTab,
      votes: 0,
      replies: []
    };
    commentsStore[key].unshift(entry);
    if (QA_SYNC_URL) {
      postRemote({ action: 'post', lesson: currentLessonId, tab: activeTab, body: val, author: CUSTOMER_NAME });
    } else {
      persistComments();
    }
    rawInput.value = '';
    parseAndRenderComments();
  });

  function persistComments() {
    try { localStorage.setItem(commentsKey, JSON.stringify(commentsStore)); } catch (e) {}
  }

  // Base Seed Data
  const baseSeed = [
    {
      id: "seed-1",
      author: "Mordecai Eyram Wornyo",
      date: "3 years ago",
      timestamp: 1609459200,
      body: "How do we differentiate between deep sleep and REM cycles when measuring our metrics?",
      tab: "questions",
      votes: 3,
      replies: [
        {
          id: "seed-reply-1",
          author: "KLaudano",
          date: "3 years ago",
          timestamp: 1609459200,
          body: "Deep sleep (slow-wave sleep) is mostly about physical recovery and occurs early in the night, whereas REM is more about mental integration and happens more towards the morning.",
          votes: 6
        }
      ]
    },
    {
      id: "seed-2",
      author: "155057",
      date: "2 years ago",
      timestamp: 1640995200,
      body: "when do you use text vs charts to monitor sleep progress?",
      tab: "questions",
      votes: 1,
      replies: []
    }
  ];

  // Displayed votes = base votes + this user's own contribution
  function displayVotes(item) {
    const base = item.votes || 0;
    const dir = window.EWHQ ? window.EWHQ.getVote(item.id) : null;
    return base + (dir === 'up' ? 1 : dir === 'down' ? -1 : 0);
  }

  const qaLoaded = {};
  function loadRemoteComments(key, lessonId, tab) {
    return fetch(QA_SYNC_URL + (QA_SYNC_URL.indexOf('?') >= 0 ? '&' : '?') +
      'lesson=' + encodeURIComponent(lessonId) + '&tab=' + encodeURIComponent(tab), { headers: { 'Accept': 'application/json' } })
      .then(r => r.ok ? r.json() : [])
      .then(data => { commentsStore[key] = Array.isArray(data) ? data : (data.items || []); qaLoaded[key] = true; })
      .catch(() => { qaLoaded[key] = true; });
  }
  function postRemote(payload) {
    if (!QA_SYNC_URL) return Promise.resolve();
    return fetch(QA_SYNC_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).catch(() => {});
  }

  function parseAndRenderComments() {
    const threadList = document.getElementById('qa-thread-list');
    if (!threadList) return;

    const key = `${currentLessonId}_${activeTab}`;

    // Backend mode: shared Q&A across all members via app proxy.
    if (QA_SYNC_URL && !qaLoaded[key]) {
      threadList.innerHTML = '<div class="qa-loading" style="opacity:0.6;padding:1rem 0;">Loading discussion…</div>';
      loadRemoteComments(key, currentLessonId, activeTab).then(parseAndRenderComments);
      return;
    }

    threadList.innerHTML = '';
    let itemsList = commentsStore[key] || [];

    // Only seed illustrative starter content in local (no-backend) mode.
    if (itemsList.length === 0 && !QA_SYNC_URL) {
      commentsStore[key] = JSON.parse(JSON.stringify(baseSeed.filter(item => item.tab === activeTab)));
      persistComments();
      itemsList = commentsStore[key];
    }

    if (sortCriteria === 'votes') {
      itemsList.sort((a, b) => displayVotes(b) - displayVotes(a));
    } else {
      itemsList.sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
    }

    itemsList.forEach(post => {
      const threadEl = document.createElement('div');
      threadEl.className = 'qa-thread';

      const storedVote = window.EWHQ ? window.EWHQ.getVote(post.id) : null;
      const replyLinkText = post.replies && post.replies.length > 0 ? `${post.replies.length} replies` : 'Reply';

      threadEl.innerHTML = `
        <div class="qa-node">
          <div class="user-avatar">${escapeHTML((post.author || '?').charAt(0).toUpperCase())}</div>
          <div class="qa-content">
            <div class="qa-meta">
              <span class="qa-author">${escapeHTML(post.author || 'Anonymous')}</span>
              <span class="qa-time">${escapeHTML(post.date || 'Just now')}</span>
            </div>
            <div class="qa-body">${escapeHTML(post.body)}</div>
            <div class="qa-actions">
              <button class="qa-action-link reply-toggle-btn" data-id="${post.id}">${replyLinkText}</button>
              <div class="qa-voting">
                <span class="qa-votes-count">(${displayVotes(post)} votes)</span>
                <button class="qa-vote-btn vote-up ${storedVote === 'up' ? 'active' : ''}" data-id="${post.id}" data-dir="up">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="18 15 12 9 6 15"></polyline></svg> Up
                </button>
                <button class="qa-vote-btn vote-down ${storedVote === 'down' ? 'active' : ''}" data-id="${post.id}" data-dir="down">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"></polyline></svg> Down
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="qa-replies">
          ${(post.replies || []).map(reply => {
            const replyVote = window.EWHQ ? window.EWHQ.getVote(reply.id) : null;
            return `
              <div class="qa-node">
                <div class="user-avatar">${escapeHTML((reply.author || '?').charAt(0).toUpperCase())}</div>
                <div class="qa-content">
                  <div class="qa-meta">
                    <span class="qa-author">${escapeHTML(reply.author || 'Anonymous')}</span>
                    <span class="qa-time">${escapeHTML(reply.date || 'Just now')}</span>
                  </div>
                  <div class="qa-body">${escapeHTML(reply.body)}</div>
                  <div class="qa-actions">
                    <div class="qa-voting" style="margin-left:0;">
                      <span class="qa-votes-count">(${displayVotes(reply)} votes)</span>
                      <button class="qa-vote-btn vote-up ${replyVote === 'up' ? 'active' : ''}" data-id="${reply.id}" data-dir="up">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="18 15 12 9 6 15"></polyline></svg>
                      </button>
                      <button class="qa-vote-btn vote-down ${replyVote === 'down' ? 'active' : ''}" data-id="${reply.id}" data-dir="down">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"></polyline></svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            `;
          }).join('')}
        </div>

        <div class="qa-reply-form-container" id="reply-form-for-${post.id}">
          <div class="qa-input-block" style="margin-bottom:0; margin-top:1rem;">
            <div class="user-avatar">${escapeHTML(CUSTOMER_INITIAL)}</div>
            <div class="qa-form">
              <textarea class="qa-textarea" placeholder="Write a reply..." id="textarea-for-${post.id}"></textarea>
              <div class="qa-form-footer">
                <button class="qa-submit-btn submit-reply-action-btn" data-parent-id="${post.id}">Post reply</button>
              </div>
            </div>
          </div>
        </div>
      `;

      threadList.appendChild(threadEl);
    });

    bindInteractionEvents();
  }

  function bindInteractionEvents() {
    document.querySelectorAll('.reply-toggle-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const form = document.getElementById(`reply-form-for-${btn.dataset.id}`);
        if (form) {
          form.classList.toggle('active');
          if (form.classList.contains('active')) form.querySelector('textarea').focus();
        }
      });
    });

    document.querySelectorAll('.submit-reply-action-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const parentId = btn.dataset.parentId;
        const replyTextarea = document.getElementById(`textarea-for-${parentId}`);
        const replyText = replyTextarea.value.trim();
        if (!replyText) return;

        const key = `${currentLessonId}_${activeTab}`;
        const postIndex = (commentsStore[key] || []).findIndex(p => p.id === parentId);
        if (postIndex !== -1) {
          commentsStore[key][postIndex].replies.push({
            id: 'local-reply-' + Date.now(),
            author: CUSTOMER_NAME,
            timestamp: Math.floor(Date.now() / 1000),
            date: 'Just now',
            body: replyText,
            votes: 0
          });
          if (QA_SYNC_URL) {
            postRemote({ action: 'reply', lesson: currentLessonId, tab: activeTab, parent_id: parentId, body: replyText, author: CUSTOMER_NAME });
          } else {
            persistComments();
          }
          parseAndRenderComments();
        }
      });
    });

    document.querySelectorAll('.qa-vote-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        if (window.EWHQ) window.EWHQ.setVote(btn.dataset.id, btn.dataset.dir);
        parseAndRenderComments();
      });
    });
  }

  function escapeHTML(str) {
    return String(str == null ? '' : str).replace(/[&<>'"]/g,
      tag => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[tag] || tag)
    );
  }

  /* ============================================================
     TPI-PERSONALIZED LEARNING PATH
     Highlights lessons matching the member's weakest pillars and
     surfaces a recommended starting point.
  ============================================================ */
  const PILLAR_LABEL = { recovery: 'Recovery', sleep: 'Sleep', stress: 'Stress', energy: 'Energy', longevity: 'Longevity' };
  function getFocusPillars() {
    if (!window.EWHQ) return [];
    let focus = window.EWHQ.getPref('focus');
    if (!focus || !focus.length) {
      const a = window.EWHQ.getAssessment();
      focus = (a && a.focus_areas) || [];
    }
    return Array.isArray(focus) ? focus : [];
  }
  function applyRecommendations() {
    const focus = getFocusPillars();
    const banner = document.getElementById('lh-recpath');
    const recommended = [];
    lessons.forEach(l => {
      const p = l.dataset.pillar;
      const badge = l.querySelector('.lesson-rec-badge');
      const match = p && focus.indexOf(p) !== -1;
      if (badge) badge.hidden = !match;
      l.classList.toggle('is-recommended', !!match);
      if (match) recommended.push(l);
    });
    if (banner) {
      if (focus.length && recommended.length) {
        const labels = focus.map(f => PILLAR_LABEL[f] || f).join(' & ');
        banner.hidden = false;
        banner.innerHTML = 'Based on your TPI, your biggest leverage is <strong>' + escapeHTML(labels) +
          '</strong>. We\'ve tagged ' + recommended.length + ' lesson' + (recommended.length === 1 ? '' : 's') + ' as <strong>For you</strong> — a great place to start.';
      } else if (focus.length) {
        banner.hidden = true;
      } else {
        banner.hidden = false;
        banner.innerHTML = 'Take the <a href="/pages/wellness-assessment" style="color:var(--lh-accent);font-weight:600;">Wellness Assessment</a> to get a learning path personalized to your body.';
      }
    }
    return recommended;
  }

  /* ============================================================
     CERTIFICATE OF COMPLETION (canvas → PNG)
  ============================================================ */
  const certSection = document.getElementById('lh-cert');
  const certBtn = document.getElementById('lh-cert-btn');
  function updateCertificate() {
    if (!certSection) return;
    let done = 0;
    lessons.forEach(l => { if (isComplete(l.dataset.id)) done++; });
    certSection.hidden = !(lessons.length > 0 && done === lessons.length);
  }
  function drawCertificate() {
    const canvas = document.getElementById('lh-cert-canvas');
    if (!canvas) return null;
    const ctx = canvas.getContext('2d');
    const W = canvas.width, H = canvas.height;
    ctx.fillStyle = '#0d0f12'; ctx.fillRect(0, 0, W, H);
    // border
    ctx.strokeStyle = '#f5c453'; ctx.lineWidth = 8; ctx.strokeRect(40, 40, W - 80, H - 80);
    ctx.strokeStyle = 'rgba(0,113,227,0.6)'; ctx.lineWidth = 2; ctx.strokeRect(60, 60, W - 120, H - 120);
    ctx.textAlign = 'center';
    ctx.fillStyle = 'rgba(255,255,255,0.6)'; ctx.font = '600 34px Georgia, serif';
    ctx.fillText('ELITE WELLNESS HQ', W / 2, 200);
    ctx.fillStyle = '#ffffff'; ctx.font = 'italic 30px Georgia, serif';
    ctx.fillText('Certificate of Completion', W / 2, 300);
    ctx.fillStyle = 'rgba(255,255,255,0.7)'; ctx.font = '26px Georgia, serif';
    ctx.fillText('This certifies that', W / 2, 430);
    ctx.fillStyle = '#f5c453'; ctx.font = '700 64px Georgia, serif';
    ctx.fillText(CUSTOMER_NAME || 'Wellness Member', W / 2, 520);
    ctx.fillStyle = 'rgba(255,255,255,0.8)'; ctx.font = '26px Georgia, serif';
    ctx.fillText('has successfully completed the Elite Wellness HQ', W / 2, 620);
    ctx.fillText('Recovery & Longevity Education Curriculum', W / 2, 660);
    ctx.strokeStyle = 'rgba(255,255,255,0.4)'; ctx.lineWidth = 1;
    ctx.beginPath(); ctx.moveTo(W / 2 - 220, 820); ctx.lineTo(W / 2 + 220, 820); ctx.stroke();
    ctx.fillStyle = 'rgba(255,255,255,0.6)'; ctx.font = '22px Georgia, serif';
    ctx.fillText(new Date().toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' }), W / 2, 860);
    return canvas;
  }
  if (certBtn) {
    certBtn.addEventListener('click', () => {
      const canvas = drawCertificate();
      if (!canvas) return;
      canvas.toBlob(blob => {
        if (!blob) return;
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url; a.download = 'ewhq-certificate.png';
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(() => URL.revokeObjectURL(url), 4000);
      }, 'image/png');
    });
  }

  /* ============================================================
     INITIALIZATION — recommended path + continue where you left off
  ============================================================ */
  function bootstrap() {
    syncUI();
    updateCertificate();
    const recommended = applyRecommendations();
    if (lessons.length > 0) {
      let startLesson = lessons[0];
      const lastId = window.EWHQ && window.EWHQ.getPref ? window.EWHQ.getPref('lh_last_lesson') : null;
      if (lastId) {
        const remembered = lessons.find(l => l.dataset.id === lastId);
        if (remembered) startLesson = remembered;
      } else if (recommended && recommended.length) {
        // First-time visitors with a TPI start on their first recommended lesson.
        startLesson = recommended[0];
      }
      loadLesson(startLesson, { skipScroll: true });
    }
  }
  if (window.EWHQ) bootstrap();
  else document.addEventListener('ewhq:ready', bootstrap, { once: true });
});
